import { ClientInferRequest } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { translateApiError } from "#app/i18n/translateApiError";
import { ApiError } from "#shared/infra/apiError";

export type CreateMaterialLayoutDto = ClientInferRequest<
  typeof contract.materialLayouts.create
>["body"];

export const createMaterialLayout = async ({ payload }: { payload: CreateMaterialLayoutDto }) => {
  const response = await api.materialLayouts.create.mutation({
    body: payload,
  });

  if (response.status === 201) {
    return response.body;
  }

  if (response.status >= 400) {
    throw new ApiError(translateApiError(response.body), response.status, response.body);
  }

  throw new ApiError("Failed to create MaterialLayout", response.status, response.body);
};
